import ConnectedContainer from "components/container/ConnectedContainer.tsx";
import {useAppDispatch, useAppSelector} from "config/store";
import {authActions} from "config/store/modules/auth.ts";
import {tryAsyncFunc} from "globals/functions/async.ts";
import ajax from "config/ajax.ts";
import LoadingContainer from "components/container/LoadingContainer.tsx";
import {Form, Formik} from "formik";
import Input from "components/atom/Input.tsx";
import Button from "components/atom/button/Button.tsx";
import {useTranslation} from "react-i18next";
import {UserType} from "globals/types/models.ts";

function MePasswordPage() {
    const {t} = useTranslation()
    const dispatch = useAppDispatch()
    const currentUser: UserType | null = useAppSelector(state => state.auth.user)

    const values = {
        currentPassword: '',
        newPassword: '',
        confirmNewPassword: '',
    }

    if (!currentUser) {
        return null;
    }

    return (
        <ConnectedContainer title={t('menu.changePwd')}>
            <div className="mx-auto w-full md:max-w-[506px]">
                <Formik
                    initialValues={values}
                    validateOnChange={false}
                    validateOnBlur={false}
                    validate={values => {
                        const errors: Partial<{ [K in keyof typeof values]: string }> = {};//same keys as type but with string value
                        if (!values.currentPassword) {
                            errors.currentPassword = t('forms.errors.requiredPassword')
                        }
                        if (!values.newPassword) {
                            errors.newPassword = t('forms.errors.requiredPassword')
                        }
                        if (values.newPassword !== values.confirmNewPassword) {
                            errors.confirmNewPassword = t('forms.errors.validateConfirmPassword')
                        }
                        return errors;
                    }}
                    onSubmit={async (values, {setSubmitting, setStatus, setFieldError, resetForm}) => {
                        setSubmitting(true);
                        setStatus(null);

                        const [res, err] = await tryAsyncFunc(ajax.put('/connected/me/password', values))
                        setSubmitting(false);

                        if (err) {
                            const errData = err.response.data || {}
                            const errors = errData.errors || {}

                            if (errors.global) {
                                setStatus(errors.global)
                                delete errors.global
                            }

                            Object.keys(errors).forEach(errKey => {
                                setFieldError(errKey, errors[errKey])
                            })
                            return
                        }

                        await dispatch(authActions.setUser(res.data.user))
                        resetForm({
                            values: {
                                currentPassword: '',
                                newPassword: '',
                                confirmNewPassword: '',
                            }
                        })
                    }}
                >
                    {({isSubmitting, status}) => (
                        <LoadingContainer isLoading={isSubmitting} keepChildren>
                            <Form>
                                <Input autoComplete="current-password" name="currentPassword" type="password"
                                       label={t('forms.currentPassword')}/>

                                <Input name="newPassword" type="password"
                                       label={t('forms.newPassword')}/>

                                <Input name="confirmNewPassword" type="password"
                                       label={t('forms.confirmNewPassword')}/>

                                {status && (
                                    <p className="error block">{status}</p>
                                )}
                                <div className="mt-4 flex w-full flex-row items-center justify-center">
                                    <Button className="w-full" type="submit" disabled={isSubmitting}>
                                        {t('save')}
                                    </Button>
                                </div>
                            </Form>
                        </LoadingContainer>
                    )}
                </Formik>
            </div>
        </ConnectedContainer>

    )
}

export default MePasswordPage
